import React, { FC } from 'react'

const Separator: FC = () => <div className="w-0.5 h-0.5 border-brand-gray-400 border-opacity-70 rounded-full border" />

export default Separator
